<div
  class="flex flex-col gap-4 rounded-[8px] p-4 box-border w-full bg-neutrals-0 border-neutrals-500"
>
  <div class="flex justify-between items-center">
    <ui-paragraph
      type="p12"
      mobile-type="p12"
      font-weight="semibold"
      text-color="neutrals-700"
    >
      {{ item.title }}
    </ui-paragraph>
    <unicon-menu-tooltip>
      <div menuTooltipContent class="flex flex-col gap-3">
        <ui-paragraph
          type="p14"
          mobile-type="p14"
          font-weight="semibold"
          text-color="neutrals-900"
        >
          {{ item.title }}
        </ui-paragraph>
        <ui-paragraph
          type="p12"
          mobile-type="p12"
          font-weight="regular"
          text-color="neutrals-900"
        >
          {{ item.message }}
        </ui-paragraph>
      </div>
    </unicon-menu-tooltip>
  </div>
  <div class="flex flex-col justify-center items-center box-border gap-3">
    <div class="flex items-baseline gap-[6px] w-full">
      <div class="value-wrapper">
        <ui-headline
          type="h64"
          mobile-type="h64"
          font-weight="bold"
          text-color="neutrals-900"
        >
          {{ item.value }} {{ item.suffix ? ' ' + item.suffix : '' }}
        </ui-headline>
      </div>
    </div>
    <unicon-percent-indicator
      class="flex-none"
      [positive]="item.percent >= 0"
      [percent]="item.percent"
    />
  </div>
  <div class="flex flex-col gap-2" *ngIf="item.goal">
    <ui-paragraph
      type="p10"
      mobile-type="p10"
      font-weight="regular"
      text-color="neutrals-700"
    >
      Meta {{ item.goal }}
    </ui-paragraph>

    <div class="w-full h-3 rounded-[4px] min-h-3 bg-neutrals-300">
      <div class="w-[72%] h-3 rounded-[4px] min-h-3 bg-neutrals-900"></div>
    </div>

    <div class="flex flex-row justify-between">
      <ui-paragraph
        type="p10"
        mobile-type="p10"
        font-weight="bold"
        text-color="neutrals-900"
      >
        {{ item.goalAchieved }}
      </ui-paragraph>
      <ui-paragraph
        type="p10"
        mobile-type="p10"
        font-weight="bold"
        text-color="neutrals-500"
      >
        {{ item.amount }}
      </ui-paragraph>
    </div>
  </div>
</div>
